var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"location",class:_vm.appClass,attrs:{"id":"app"}},[_c('Preloader'),_c('MainLayout')],1)}
var staticRenderFns = []

export { render, staticRenderFns }